import { Observable } from 'rxjs';
import { DataSourceResponse, IntegrationSetting } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class IntegrationSettingService extends ApiService {
    endPoint = '/api/integrationSetting';
    create(model: IntegrationSetting) {
        return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
    }

    update(id: string, model: IntegrationSetting) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
    }

    delete(id: string) {
        return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
    }

    get(id: string): Observable<IntegrationSetting> {
        return this.http.get<IntegrationSetting>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
    }
    getForClinic(): Observable<IntegrationSetting> {
        return this.http.get<IntegrationSetting>(`${this.clinicsBaseURL}${this.endPoint}/for-clinic`);
    }
    switchIsActive(id: string,isActive:boolean): Observable<IntegrationSetting> {
        return this.http.get<IntegrationSetting>(`${this.clinicsBaseURL}${this.endPoint}/switch/${id}/${isActive}`);
    }

    getList(queryParams: any): Observable<DataSourceResponse<IntegrationSetting>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
    }
}
